module.exports = __webpack_public_path__ + "img/illustration-login2-blue 2.adcacfb0.svg";